import { transitionAfyaImaraMedicalHistoryForm } from '../../../actions/afyaImara/medicalHistory';
import { getMedicalHistoryForm } from '../../../selectors/afyaImara/medicalHistory';

import { FIELD_STATUS } from '../../../reducers/status';

export const medicalHistoryFormRules = (store, next, action) => {
    const result = next(action);
    const medicalHistoryForm = getMedicalHistoryForm(store.getState());
    const medicalHistoryFormValid = validateMedicalHistoryFormDetails(medicalHistoryForm);
    const formAction = medicalHistoryFormValid
        ? transitionAfyaImaraMedicalHistoryForm.formValid()
        : transitionAfyaImaraMedicalHistoryForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateMedicalHistoryFormDetails = (formFields) => {
    return (
        formFields.relationship &&
        formFields.relationship.status === FIELD_STATUS.VALID &&
        formFields.name &&
        formFields.name.status === FIELD_STATUS.VALID &&
        formFields.idBirthCertificate &&
        formFields.idBirthCertificate.status === FIELD_STATUS.VALID &&
        formFields.dateOfOnset &&
        formFields.dateOfOnset.status === FIELD_STATUS.VALID &&
        // formFields.diagnosis &&
        // formFields.diagnosis.status === FIELD_STATUS.VALID &&
        formFields.dateOfLastEpisode &&
        formFields.dateOfLastEpisode.status === FIELD_STATUS.VALID
    );
};
